import React, { useEffect } from "react";
import img2 from "../assets/occupancy_counting_system.png";
import Footer from "../components/Footer";


const OccupancyCountingSystem = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="App">
            <div className="container py-5 main-content" style={{ marginTop: "50px" }}>
                <h1>Occupancy Counting System</h1>

                <p className="lead">
                    The <strong> Occupancy Counting System </strong> uses advanced sensors to track real-time occupancy within a room,
                    cabin, or facility area.
                    It helps optimize space utilization, ensure compliance with safety norms, and manage HVAC or lighting
                    automation efficiently. Data is processed locally and shared securely with the cloud dashboard for
                    instant visibility and analytics.

                </p>

                <div className="row my-4">

                    <div className="col-md-12 mb-5 d-flex justify-content-center">
                        <div className="img-card h-100 d-flex align-items-center justify-content-center">
                            <img
                                src={img2}
                                alt="Occupancy Counting System Image "
                                className="img-fluid rounded shadow"
                                style={{ maxHeight: "400px", objectFit: "contain" }}
                            />
                        </div>
                    </div>
                </div>

                <style>{`
                        .img-card {
                            background: #f8fafc;
                            border: 1px solid #e3e8ee;
                            border-radius: 16px;
                            padding: 24px;
                            box-shadow: 0 4px 24px rgba(25, 118, 210, 0.07);
                            transition: box-shadow 0.2s, transform 0.2s;
                            min-height: 260px;
                        }
                        .img-card:hover {
                            box-shadow: 0 8px 32px rgba(25, 118, 210, 0.15);
                            transform: translateY(-4px) scale(1.02);
                        }
                `}</style>
            </div>
            <Footer />
        </div>
    );
};

export default OccupancyCountingSystem;
